<div class="po-row " style="border-bottom: 1px solid #d3d3d3;">
</div>
<div *ngIf="lastCountedList.length == 0">
    <div class="po-text-center po-mt-1 po-mb-1">
        <span class="po-ml-1 po-font-text-smaller ">Nenhum item contado...</span>
    </div>
</div>
<div *ngIf="lastCountedList.length > 0">
    <div *ngFor="let item of lastCountedList; let i = index">
        <div class="po-row po-pt-1">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center  add-dots"
                [title]="item.productCode + ' - '+ item.description">
                <span class="po-text-color-01 po-font-text-smaller">{{item.productCode}}</span>
                <span class="po-ml-1 po-font-text-smaller">{{item.description}}</span>
            </div>
        </div>
    </div>
</div>